import styled from 'styled-components'

export const ToolBarContainer = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-auto-flow: column;
`

export const ComponentPlaceHolder = styled.div``
